import React from 'react';
import PropTypes from 'prop-types';

export default function Broadcast({ broadcasts }) {
    return broadcasts
        .filter(broadcast => !!broadcast.heading && !!broadcast.message)
        .map(broadcast => (
            <section className="broadcast u-mb16" data-testid="broadcast" key={broadcast.heading}>
                <div className="broadcast__content">
                    <h2 className="u-t3">{broadcast.heading}</h2>
                    <span dangerouslySetInnerHTML={{ __html: broadcast.message }} />
                </div>
            </section>
        ));
}

// TODO fetch broadcasts itself, maybe with useEffect?

Broadcast.propTypes = {
    broadcasts: PropTypes.array.isRequired,
};
